import { createContext } from 'react'

const headContext = createContext()
headContext.displayName = 'InertiaHeadContext'

export default headContext
